var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10.4999L7.66667 8.16679M8.77778 5.38901C8.77778 5.89971 8.67719 6.4054 8.48175 6.87722C8.28632 7.34905 7.99987 7.77775 7.63875 8.13887C7.27763 8.49999 6.84892 8.78644 6.3771 8.98188C5.90528 9.17731 5.39959 9.2779 4.88889 9.2779C4.37819 9.2779 3.8725 9.17731 3.40068 8.98188C2.92885 8.78644 2.50015 8.49999 2.13903 8.13887C1.77791 7.77775 1.49146 7.34905 1.29602 6.87722C1.10059 6.4054 1 5.89971 1 5.38901C1 4.35761 1.40972 3.36846 2.13903 2.63915C2.86834 1.90984 3.85749 1.50012 4.88889 1.50012C5.92029 1.50012 6.90944 1.90984 7.63875 2.63915C8.36806 3.36846 8.77778 4.35761 8.77778 5.38901Z",
    stroke: "#1F2A37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.8deaa7ecd22d3fa1ed90d937779db1fa.svg";
export { ForwardRef as ReactComponent };